import React from "react";
import "styled-components/macro";
import { HomePageRefresh } from "../HomePageRefresh";

export const NewSplashPage = ({ location }) => (
  <HomePageRefresh location={location} />
);

export default NewSplashPage;
